import React, { useState, useEffect, useRef } from 'react';
import { Modal } from "react-bootstrap";
import { startCase, capitalize } from "lodash";
import showAlert from "utils/showAlert";
import jsDig from "utils/jsDig.js";

// Dashboard options is structured like this in DB
// {
//  "dashboard_name": {
//    "modifier_name": {
//      "enabled": true,
//      "config": {
//        "option_name": "value"
//      }
//    }
//  }
// }

export default function DashboardOptions(props) {
  console.log(props);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => setIsModalVisible(true);
  const hideModal = () => setIsModalVisible(false);
  const [dashboardOptions, setDashboardOptions] = useState(props.dashboardOptions);
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

  const dashboardModifiers = {
    "overview": [],
    "paid_social": [],
    "paid_search": [
      {
        "name": "show_branded_and_non_branded_l7d_tables",
        "title": "Show Branded and Non-Branded L7D Tables",
        "desc": "Show the Branded and Non-Branded L7D tables on the Paid Search dashboard.",
        "options": []
      },
    ],
    "organic_social": [],
    "organic_search": [],
    "email": [],
    "amazon": [],
    "other": [],
  }
  const currentModifiers = dashboardModifiers[props.dashboardType];

  const handleCheckbox = (e, name) => {
    const isChecked = e.target.checked;
    const newDashboardOptions = {
      ...dashboardOptions,
      [props.dashboardType]: {
        ...jsDig([props.dashboardType], dashboardOptions),
        [name]: {
          enabled: isChecked,
          config: jsDig([props.dashboardType, name, "config"], dashboardOptions) || {}
        }
      }
    };
    setDashboardOptions(newDashboardOptions);
  }

  const handleModifierConfigChange = (e, modifierName, optionName) => {
    const newValue = e.target.value;
    const newDashboardOptions = {
      ...dashboardOptions,
      [props.dashboardType]: {
        ...jsDig([props.dashboardType], dashboardOptions),
        [modifierName]: {
          enabled: jsDig([props.dashboardType, modifierName, "enabled"], dashboardOptions),
          config: {
            ...jsDig([props.dashboardType, modifierName, "config"], dashboardOptions),
            [optionName]: newValue
          }
        }
      }
    };
    setDashboardOptions(newDashboardOptions);
  }

  const saveDashboardOptions = async () => {
    console.log('Saving dashboard options', dashboardOptions);
    const response = await fetch('/datapulse/dashboards/update-dashboard-options', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': authenticityToken,
      },
      body: JSON.stringify({
        account_id: props.accountId,
        dashboard_options: dashboardOptions
      })
    });

    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        console.log('Dashboard options saved successfully', data);
        props.setDashboardOptions(dashboardOptions);
        hideModal();
        showAlert("Saved dashboard options")
      } else {
        console.error('Failed to save dashboard options');
        showAlert('Failed to save dashboard options', 'danger');
      }
    }
  }
 
  return (
    <>
      {currentModifiers.length > 0 && (
        <>
          <button className="dashboard-header-button" onClick={showModal}>
            <p>Dashboard<span className="desktop-only"> options</span></p>
          </button>
          <Modal className="lite-modal-2 dashboard-options" show={isModalVisible} onHide={hideModal} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>
                <h4>{startCase(props.dashboardType)} Dashboard Options</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="dashboard-options-container-inner p-3">
                {currentModifiers.map((modifier) => {
                  const defaultChecked = props.dashboardOptions && jsDig([props.dashboardType, modifier.name, "enabled"], props.dashboardOptions) == true ? true : false;
                  return (
                    <div key={modifier.name} className="modifier-box text-primary">
                      <div className="h-100 modifier-box-bg">
                        <div className="mb-2">
                          <div className="lite-checkbox-container">
                            <input
                              type="checkbox"
                              className="lite-checkbox "
                              id={`dashboard_option_${modifier.name}`}
                              name={`dashboard_option[${modifier.name}]`}
                              defaultChecked={defaultChecked}
                              onChange={(e) => handleCheckbox(e, modifier.name)}
                            />
                            <label className="custom-label" htmlFor={`dashboard_option_${modifier.name}`}>{modifier.title}</label>
                          </div>
                        </div>
                        <div>
                          <p className="f14">{modifier.desc}</p>
                        </div>

                        {modifier.options && (
                          <div className="modifier-options pt-2">
                            <div className="d-flex flex-column" style={{gap: "8px"}}>
                              {modifier.options.map((option) => {
                                const defaultValue = jsDig([props.dashboardType, modifier.name, "config", option.name], props.dashboardOptions);
                                return (
                                  <div className="mb-0 form-group" key={`${modifier.name}-${option.name}`}>
                                    <label className="f12 font-weight-bold pb-2 form-label" htmlFor={`dashboard_option[${modifier.name}][${option.name}]`}>
                                      {option.title}
                                    </label>
                                    {option.desc && (
                                      <p className="f12 mb-2"><i>{option.desc}</i></p>
                                    )}
                                    <input 
                                      name={`dashboard_option[${modifier.name}][${option.name}]`} 
                                      type="text"
                                      className="form-control"
                                      placeholder={option.placeholder}
                                      defaultValue={defaultValue}
                                      onChange={(e) => handleModifierConfigChange(e, modifier.name, option.name)}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="dashboard-options-footer lite-flexbox mt-4 justify-content-end">
                <button type="button" className="button b-type-primary b-size-small mr-3" onClick={hideModal}>Cancel</button>
                <button className="button b-type-primary b-size-small b-color-green" onClick={(e) => saveDashboardOptions()}>Save options</button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

// const updateRefreshPreference = async (autoRefresh) => {
//   const params = new URLSearchParams({
//     default_refresh: autoRefresh == true ? 1 : 0
//   });
//   try {
//     const response = await fetch(`/datapulse/update-default-refresh?${params.toString()}`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'X-CSRF-Token': authenticityToken,
//       },
//     });

//     if (response.ok) {
//       const data = await response.json();
//       console.log('Refresh preference updated successfully', data);
//     } else {
//       console.error('Failed to update refresh preference');
//     }
//   } catch (error) {
//     console.error('Network error:', error);
//   }

// }